<template>
  <div
    :class="
      'relative min-h-full px-8 pt-5 pb-5 rounded-md ' +
      colorTemplate.background +
      ' ' +
      colorTemplate.shadow
    "
    @mouseleave="
      hideFiligrane();
      closeMore();
    "
    @mouseenter="showFiligrane()"
  >
    <!-- Filigrane -->
    <transition
      enter-active-class="ease-out duration-300"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="ease-in duration-200"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        class="top-0 left-0 bg-indigo-600 bg-opacity-85 absolute w-full h-full rounded-md p-6 z-20 flex justify-center items-center cursor-default"
        v-if="isFiligrane"
      >
        <!-- Filigrane contents -->
        <div
          class="absolute right-4 top-4 p-2 cursor-pointer"
          @click.stop="displayMore()"
          v-if="!isMoreDisplayed"
        >
          <icon name="more-vertical" class="text-white" />
        </div>

        <div
          class="absolute right-6 top-6 flex space-x-3"
          v-if="isMoreDisplayed"
        >
          <div
            class="cursor-pointer"
            v-if="canEdit && $can(constants.PERMISSION_DEPOT_DOCUMENTS_MOVE)"
            @click.stop="moveFolder()"
          >
            <icon name="foldermove" class="text-white transform" />
          </div>
          <div
            v-if="
              isAdmin &&
              canEdit &&
              $can(constants.PERMISSION_DEPOT_DOCUMENTS_SHARE) &&
              !$freeParticulier()
            "
            class="cursor-pointer"
            @click.stop="addMember()"
          >
            <icon name="person-add" class="text-white" />
          </div>
          <div class="cursor-pointer" @click.stop="downloadFolder">
            <icon name="download" class="text-white" />
          </div>
          <div
            v-if="canEdit && $can(constants.PERMISSION_DEPOT_DOCUMENTS_EDIT)"
            class="cursor-pointer"
            @click.stop="editFolder()"
          >
            <icon name="edit" class="text-white" />
          </div>
          <div
            v-if="canEdit && $can(constants.PERMISSION_DEPOT_DOCUMENTS_DELETE)"
            class="cursor-pointer"
            @click.stop="deleteFolder()"
          >
            <icon name="trash-2" class="text-white" />
          </div>
        </div>

        <div
          class="border border-pink-600 rounded-full py-1.5 px-3.5 flex justify-center text-center text-white text-base w-max cursor-pointer transition-all duration-300 hover:bg-white hover:text-indigo-600"
          @click.stop="openFolder()"
        >
          Ouvrir le dossier
        </div>
        <!-- END Filigrane contents -->
      </div>
    </transition>
    <!-- END Filigrane -->

    <div class="flex space-x-3 items-baseline h-16">
      <icon
        :name="isOwner ? 'folder-propriete' : 'folder'"
        :class="colorTemplate.icon + ' w-5 h-5'"
      />
      <h5 :class="colorTemplate.title + ' leading-6 text-left'">
        {{ folderName }}
      </h5>
    </div>

    <div :class="colorTemplate.line + ' border-b my-4'" />

    <div :class="!smaller ? 'grid grid-cols-2 gap-2 items-center' : ''">
      <div
        :class="
          (smaller ? 'grid grid-rows-4' : 'col-span-1 grid grid-rows-3') +
          ' gap-y-1'
        "
      >
        <div
          v-if="nbFolders > 0"
          class="row-span-1 flex items-center space-x-1.5"
        >
          <icon name="folder" class="text-gray-900 h-4" />
          <p class="text-base">
            {{ nbFolders }} dossier<span v-if="nbFolders > 1">s</span>
          </p>
        </div>
        <div
          v-if="nbFiles > 0"
          class="row-span-1 flex items-center space-x-1.5"
        >
          <icon name="file" class="text-gray-900 w-4 h-4" />
          <p class="text-base">
            {{ nbFiles }} fichier<span v-if="nbFiles > 1">s</span>
          </p>
        </div>
        <div class="row-span-1 flex items-center space-x-1.5">
          <icon name="clock" class="text-gray-600 w-4 h-4" />
          <p class="text-base text-gray-600 italic font-light">
            {{ createdDate.toLocaleDateString() }}
          </p>
        </div>
        <list-avatars
          v-if="smaller"
          class="row-span-1 justify-self-end right-7"
          :list-items="sharedWith"
          libelle-firstname="firstname"
          libelle-lastname="lastname"
        />
      </div>
      <list-avatars
        v-if="!smaller"
        class="col-span-1 justify-self-end right-9 mb-1/4"
        :list-items="sharedWith"
        libelle-firstname="firstname"
        libelle-lastname="lastname"
      />
    </div>
  </div>
</template>

<script>
import Icon from './../Icon';
import ListAvatars from './../ListAvatars';
import ClickOutside from 'vue-click-outside';

import Constants from './../../constants';

export default {
  components: {
    Icon,
    ListAvatars,
  },

  props: {
    folder: {
      type: Object,
      required: false,
      defaut: {
        id: null,
        name: '',
        color: '',
        created_at: new Date(),
        users: [],
        roles: [],
      },
    },

    folders: {
      type: Array,
      required: false,
      default: [],
    },

    files: {
      type: Array,
      required: false,
      default: [],
    },

    smaller: {
      type: Boolean,
      required: false,
      default: false,
    },

    editable: {
      type: Boolean,
    },

    isAdmin: {
      type: Boolean,
    },

    isOwner: {
      type: Boolean,
    },

    inNeopassForm: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      isFiligrane: false,
      isMoreDisplayed: false,

      constants: Constants,
    };
  },

  methods: {
    showFiligrane() {
      this.isFiligrane = true;
    },

    hideFiligrane() {
      this.isFiligrane = false;
    },

    displayMore() {
      this.isMoreDisplayed = true;
    },

    closeMore() {
      this.isMoreDisplayed = false;
    },

    openFolder() {
      this.$emit('openFolder');
    },

    addMember() {
      if (this.isAdmin || this.isOwner) {
        this.$emit('addMember');
        this.$emit('loadMembers');
      }
    },

    downloadFolder() {
      this.$emit('downloadFolder');
    },

    editFolder() {
      if (this.canEdit) {
        this.$emit('editFolder');
      }
    },

    deleteFolder() {
      if (this.canEdit) {
        this.$emit('deleteFolder');
      }
    },

    moveFolder() {
      if (this.canEdit) {
        this.$emit('moveFolder');
      }
    },
  },

  computed: {
    folderName() {
      return this.folder.name;
    },
    themeColor() {
      return this.folder.color;
    },
    nbFiles() {
      return this.files.filter(
        (f) => f.folder_id === this.folder.id && f.type !== 'folder'
      ).length;
    },
    nbFolders() {
      return this.folders.filter(
        (f) => f.folder_id === this.folder.id && f.type === 'folder'
      ).length;
    },
    createdDate() {
      return new Date(this.folder.created_at);
    },
    sharedWith() {
      return this.folder.users.concat(
        this.folder.roles.map((r) => ({
          ...r,
          firstname: r.name,
          lastname: '',
        }))
      );
    },

    canEdit() {
      return this.editable || this.isAdmin || this.isOwner;
    },

    colorTemplate() {
      switch (this.themeColor) {
        case 'indigo':
          return {
            background: 'bg-indigo-200',
            icon: 'text-pink-600',
            title: 'text-indigo-600',
            shadow: 'shadow-indigo-light',
            line: 'border-pink-600',
          };

        case 'gray':
          return {
            background: 'bg-gray-200',
            icon: 'text-pink-600',
            title: 'text-gray-900',
            shadow: 'shadow-gray-light',
            line: 'border-pink-600',
          };

        case 'pink':
          return {
            background: 'bg-pink-100',
            icon: 'text-indigo-600',
            title: 'text-pink-600',
            shadow: 'shadow-pink-light',
            line: 'border-indigo-600',
          };

        case 'teal':
          return {
            background: 'bg-teal-100',
            icon: 'text-indigo-600',
            title: 'text-teal-600',
            shadow: 'shadow-teal-light',
            line: 'border-indigo-600',
          };

        case 'orange':
          return {
            background: 'bg-orange-100',
            icon: 'text-gray-900',
            title: 'text-orange-600',
            shadow: 'shadow-orange-light',
            line: 'border-gray-900',
          };

        default:
          return {
            background: 'bg-indigo-200',
            icon: 'text-pink-600',
            title: 'text-indigo-600',
            shadow: 'shadow-indigo-light',
            line: 'border-pink-600',
          };
      }
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
